import React from 'react';
import { Content, Loader, Table, Row } from 'rsuite';
// @ts-ignore
import { useCompetitividadeCategoria1 } from '../../../hooks/useCompetitividadeCategoria1.tsx';
import CurrencyFormat from 'react-currency-format';
import { HoverTooltip } from '../../../../../components/HoverTooltip';
const { Column, HeaderCell, Cell } = Table;

type RowData = {
  categoryLevel1: string;
  avg_average_competitivity_retail: string;
  count: number;
  isAboveAverage: boolean;
};

const columns = [
  {
    align: 'left',
    headerCell: 'Categoria Nível 1',
    dataKey: 'categoryLevel1',
    flexGrow: 2,
  },
  {
    align: 'left',
    headerCell: 'Competitividade',
    dataKey: 'avg_average_competitivity_retail',
    width: 80,
  },
  {
    align: 'right',
    headerCell: 'Itens',
    dataKey: 'count',
  },
  // @ts-ignore
] as Column<RowData>[];

export const CompetitividadeCategoria1: React.FC = () => {
  const { data, isLoading } = useCompetitividadeCategoria1();

  const competitividadeColor = (value: number) => {
    if (value > 105) return '#EC5B624D';
  };

  if (isLoading)
    return (
      <Content className="componente-tabela-loading">
        <Loader center />
      </Content>
    );

  if (!data || !data.length)
    return (
      <Content className="componente-tabela">
        <h2>Competitividade geral por Categoria Nível 1</h2>
        <div className="sem-dados">
          <h3>Sem dados para essa análise</h3>
          <p>Revise os filtros e tente novamente</p>
        </div>
      </Content>
    );

  return (
    <Content className="componente-tabela">
      <h2>Competitividade geral por Categoria Nível 1</h2>
      <div className="table-container">
        <Table data={data} height={385} rowHeight={32}>
          {columns.map((column, index) => (
            <Column key={index} {...column}>
              <HeaderCell className="header-tabela">
                {column.dataKey === 'avg_average_competitivity_retail' ? (
                  <HoverTooltip placement="bottom" text={column.headerCell} />
                ) : (
                  <span>{column.headerCell}</span>
                )}
              </HeaderCell>
              {column.dataKey === 'avg_average_competitivity_retail' ? (
                <Cell dataKey={column.dataKey}>
                  {(rowData: RowData) =>
                    rowData.avg_average_competitivity_retail ? (
                      <div
                        className="linha-tabela"
                        style={{
                          background: competitividadeColor(Number(rowData.avg_average_competitivity_retail.replace(',', '.'))),
                        }}
                      >
                        <CurrencyFormat
                          className="currency"
                          fixedDecimalScale
                          decimalScale={2}
                          value={rowData.avg_average_competitivity_retail}
                          displayType="text"
                          suffix="%"
                          decimalSeparator=","
                          thousandSeparator="."
                        />
                      </div>
                    ) : (
                      '--'
                    )
                  }
                </Cell>
              ) : (
                <Cell dataKey={column.dataKey}>{(rowData: RowData) => <div className="linha-tabela">{rowData[column.dataKey] || '--'}</div>}</Cell>
              )}
            </Column>
          ))}
        </Table>
      </div>
    </Content>
  );
};
